import React from 'react';

/**
 * ============================================================================
 * 组件模块：components/Logos.jsx
 * 
 * 说明：
 * - 显示学校、系和国家实验室的logo
 * - 学校logo显示在顶部
 * - 系和国家实验室logo显示在页脚
 * 
 * 【修改说明】
 * - 图片文件置于 public/images/logos/ 目录下。
 * - 下方 src 为图片路径，可按需修改；尺寸通过 className 调整。
 * - 此处可调整 logo 的样式与布局。
 * ============================================================================
 */

// 导航栏内的学校Logo组件（放在Q-Lab logo左边）
export const UniversityLogo = () => {
  return (
    <>
      {/* 此处可填写学校 logo 图片路径，对应 public/images/logos/ 下文件 */}
      <img 
        src="/images/logos/university-logo.png" 
        alt="University Logo"
        className="h-8 md:h-10 opacity-80 hover:opacity-100 transition-opacity mr-3"
        onError={(e) => {
          // 图片不存在时隐藏该元素
          e.target.style.display = 'none';
        }}
      />
    </>
  );
};

// 页脚系和国家实验室Logo组件
export const FooterLogos = () => {
  return (
    <div className="max-w-4xl mx-auto px-4">
      <div className="flex flex-wrap items-center justify-center gap-6 opacity-60 hover:opacity-100 transition-opacity">
          {/* 此处可填写系 logo 图片路径 */}
          <img 
            src="/images/logos/department-logo.png" 
            alt="Department Logo"
            className="h-8"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          
          {/* 此处可填写国家实验室 logo 图片路径 */}
          <img 
            src="/images/logos/national-lab-logo.png" 
            alt="National Lab Logo"
            className="h-8"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
    </div>
  );
};
